module.exports = __webpack_public_path__ + "img/mlh_honor_8.b764e119.png";